const CANONICAL_DOMAIN_KEY = 'universal_login_canonical_domain'
export const CANONICAL_DOMAIN_QUERY_PARAM = 'canonical_domain'

/** Persist canonical tenant domain before redirecting from universal login. */
export const setUniversalLoginCanonicalDomain = (domain: string): void => {
  if (!domain) return
  sessionStorage.setItem(CANONICAL_DOMAIN_KEY, domain)
}

/** Read and clear the canonical domain stored during universal-login redirect. */
export const consumeUniversalLoginCanonicalDomain = (): string | null => {
  const domain = sessionStorage.getItem(CANONICAL_DOMAIN_KEY)
  if (domain) {
    sessionStorage.removeItem(CANONICAL_DOMAIN_KEY)
  }
  return domain
}

/** Append canonical domain to redirect URL so it survives cross-subdomain navigation. */
export const buildUniversalLoginRedirectUrl = (
  redirectUrl: string,
  canonicalDomain?: string
): string => {
  const url = new URL(redirectUrl, window.location.origin)
  if (canonicalDomain) {
    url.searchParams.set(CANONICAL_DOMAIN_QUERY_PARAM, canonicalDomain)
  }
  return url.toString()
}

/** Resolve canonical tenant domain from URL param or same-origin sessionStorage. */
export const resolveCanonicalDomain = (searchParams: URLSearchParams): string | undefined => {
  const fromUrl = searchParams.get(CANONICAL_DOMAIN_QUERY_PARAM)
  if (fromUrl) return fromUrl
  return consumeUniversalLoginCanonicalDomain() ?? undefined
}
